<template>
  <header class="marketplace-header container">
    <router-link to="/" class="logo">
      <img src="@/assets/images/logo.svg" alt="X Global Logo" />
    </router-link>
    <div class="search-bar">
      <!-- <button class="category-button">Все категории</button> -->
      <input
        v-model="query"
        type="text"
        placeholder="Поиск по товарам и производителям"
        class="search-input"
        @keydown.enter="performSearch"
      />
      <button @click="performSearch" class="search-button">Найти</button>
    </div>
    <button
      class="login-button"
      @click.prevent="router.push('/login')"
      v-if="!isLoggedIn || !currentUser"
    >
      Войти
    </button>
    <template v-else>
      <router-link to="/profile/info" class="username">{{
        currentUser.full_name
      }}</router-link>
    </template>
  </header>
  <AuthModal />
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import AuthModal from "../components/Modals/AuthModal.vue";
import { useStore } from "vuex";

const router = useRouter();
const store = useStore();

const query = ref("");
const selectedCategory = ref("");
const isLoggedIn = computed(() => store.state.auth.status.loggedIn);
const currentUser = computed(() => store.state.user.user);

const performSearch = () => {
  const searchParams = {};
  if (query.value) searchParams.search = query.value;
  if (selectedCategory.value)
    searchParams["category__in"] = selectedCategory.value;

  router.push({ name: "Marketplace", query: searchParams });
};
</script>

<style scoped lang="scss">
.marketplace-header {
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 12px 24px;
  background-color: #fff;
  border-bottom: 1px solid #eee;

  @media (max-width: 768px) {
    gap: 12px;
  }

  .logo img {
    height: 40px;
    width: 100px;
    -o-object-fit: cover;
    object-fit: cover;
    margin-right: 10px;

    @media (max-width: 768px) {
      height: 20px;
      width: 64px;
    }
  }

  .search-bar {
    flex: 1;
    display: flex;
    border: 1px solid rgba(0, 199, 130, 1);
    border-radius: 30px;
    overflow: hidden;
    background-color: #fff;

    .category-button {
      padding: 8px 16px;
      background-color: rgba(0, 199, 130, 1);
      color: #fff;
      border: none;
      border-radius: 30px 0 0 30px;
      font-size: 14px;
    }

    .search-input {
      flex: 1;
      padding: 8px 12px;
      border: none;
      outline: none;
      font-size: 14px;
    }

    .search-button {
      background-color: rgba(0, 199, 130, 1);
      color: #fff;
      border: none;
      padding: 8px 16px;
      font-size: 14px;

      @media (max-width: 768px) {
        display: none;
      }
    }
  }

  .login-button {
    background: linear-gradient(90deg, #00c782 0%, #12986a 100%);
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 10px;
    font-size: 14px;
  }

  .username {
    text-decoration: none;
    font-family: "SF UI Display", sans-serif;
    color: rgba(0, 199, 130, 1);
    display: flex;
    align-items: center;
    // background: linear-gradient(90deg, #00c782 0%, #12986a 100%);
    border-radius: 10px;
    font-size: 20px;
    padding: 12px;

    @media (max-width: 768px) {
      font-size: 16px;
    }

    img {
      height: 25px;
      width: 25px;
      margin-left: 12px;
    }

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>

<style lang="scss">
@import "@/assets/styles/Header.scss";
@import "@/assets/styles/media.scss";
</style>
